import React, { useEffect, useRef, useState } from 'react';
import AOS from 'aos'; // AOS 스크립트 파일을 임포트
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, EffectCreative } from 'swiper/modules'; // 필요한 모듈
import heroImage from '../../assets/imgs/awsSubHero.png';
import cloud1 from '../../assets/imgs/cloud1.jpg';
import cloud2 from '../../assets/imgs/cloud2.jpg';
import cloud3 from '../../assets/imgs/cloud3.jpg';
import cloud4 from '../../assets/imgs/cloud4.jpg';
import naverSlider1 from '../../assets/imgs/awsSlider1.png';
import awsMapImg from '../../assets/imgs/awsMapimg.png';
import productBannerForCorocation from '../../assets/imgs/productBannerForCorocation.png';
import bannerImg from '../../assets/imgs/bannerImg.jpg';
import BlackArrowBtn from '../../components/global/BlackArrowBtn';
import TransparentBtn from '../../components/global/TransparentBtn';
import SectionTitle from '../../components/global/SectionTitle';
import solutionIcon1 from '../../assets/imgs/awsSolution1.svg';
import solutionIconLine1 from '../../assets/imgs/awsSolutionLine1.svg';
import solutionIcon2 from '../../assets/imgs/awsSolution2.svg';
import solutionIconLine2 from '../../assets/imgs/awsSolutionLine2.svg';
import solutionIcon3 from '../../assets/imgs/awsSolution3.svg';
import solutionIconLine3 from '../../assets/imgs/awsSolutionLine3.svg';
import solutionIcon4 from '../../assets/imgs/awsSolution4.svg';
import solutionIconLine4 from '../../assets/imgs/awsSolutionLine4.svg';
import solutionIcon5 from '../../assets/imgs/awsSolution5.svg';
import solutionIconLine5 from '../../assets/imgs/awsSolutionLine5.svg';
import solutionIcon6 from '../../assets/imgs/awsSolution6.svg';
import solutionIconLine6 from '../../assets/imgs/awsSolutionLine6.svg';
import { useModal } from '../../context/ModalContext';
import { Link } from 'react-router-dom';

const solutionData = [
  {
    title: `생성형 AI를 위한 최적의 플랫폼`,
    enTitle: `
Generative AI Solutions`,
    titleColor: '#85613A',
    themeColor: '#4A4A4A',
    icon: solutionIcon1,
    lineIcon: solutionIconLine1,
    contentTitle:
      '생성형 AI와 멀티모달 AI 애플리케이션을 쉽고 빠르게 구축할 수 있는 환경 제공.',
    contentData: [
      'Amazon Bedrock 등 최신 AI 서비스를 통해 혁신적인 비즈니스 전환을 지원합니다.',
    ],
  },
  {
    title: `최신 고성능 인프라 제공`,
    enTitle: `
High-performance infrastructure Solutions`,
    titleColor: '#1161BD',
    themeColor: '#1372DE',
    icon: solutionIcon2,
    lineIcon: solutionIconLine2,
    contentTitle:
      'Graviton4 등 최신 프로세서를 기반으로, 웹 서비스와 데이터베이스 구동 시 뛰어난 성능과 비용 효율을 동시에 실현합니다.',
    contentData: [],
  },
  {
    title: `대규모 데이터 분석을 위한 스토리지 성능`,
    enTitle: `Data Analysis Solutions`,
    titleColor: '#FF7548',
    themeColor: '#FF7B42',
    icon: solutionIcon3,
    lineIcon: solutionIconLine3,
    contentTitle:
      'S3 테이블 서비스를 통해 기존 대비 최대 3배 빠른 처리와 10배 높은 TPS를 제공',
    contentData: [
      'AI 학습, 로그 분석 등 빅데이터 환경에 최적화된 스토리지 옵션을 제공합니다.',
    ],
  },
  {
    title: `개발자 생산성 향상 도구`,
    enTitle: `Increase Development Efficiency Solutions`,
    titleColor: '#464646',
    themeColor: '#4A4A4A',
    icon: solutionIcon4,
    lineIcon: solutionIconLine4,
    contentTitle:
      'Amazon Q Developer 등 AI 기반 도구로 코드 리뷰, 테스트 자동화, 문서 정리를 지원.\n',
    contentData: [
      '개발 효율을 높이고 운영 리소스를 줄일 수 있는 스마트 개발 환경을 제공합니다.',
    ],
  },
  {
    title: `글로벌 서비스 확장에 강한 인프라`,
    enTitle: `Global Service Expansion Solutions`,
    titleColor: '#4C93FF',
    themeColor: '#31E89F',
    icon: solutionIcon5,
    lineIcon: solutionIconLine5,
    contentTitle:
      '30개 이상 리전, 수백 개의 가용영역(AZ)을 갖춘 AWS 글로벌 인프라를 통해 전 세계 어디서든 빠르고 안정적인 서비스 제공이 가능합니다.\n',
    contentData: [],
  },
  {
    title: `포괄적인 보안 및 규제 준수 체계`,
    enTitle: `Security And Regulation Solutions`,
    titleColor: '#FF7E77',
    themeColor: '#FF8A6A',
    icon: solutionIcon6,
    lineIcon: solutionIconLine6,
    contentTitle: '143개 이상 글로벌 규정과 300여 개 보안 기능 내장.',
    contentData: [
      '금융, 의료, 공공 등 규제 산업에서도 신뢰할 수 있는 보안 환경을 보장합니다.',
    ],
  },
];
const qnaData = [
  {
    q: 'AWS는 어떤 클라우드 서비스를 제공하나요?',
    a: 'AWS는 컴퓨팅, 스토리지, 데이터베이스, AI/ML, 보안, 개발자 도구 등 200개 이상의 클라우드 서비스를 제공합니다.',
  },
  {
    q: 'AWS는 왜 글로벌 기업들이 선호하나요?',
    a: '글로벌 인프라(30개 리전 이상)와 철저한 보안 관리, 다양한 컴플라이언스를 충족하는 구조로 글로벌 서비스를 운영하거나 다국적 지사와 연동이 필요한 기업들이 선호합니다.',
  },
  {
    q: 'AWS에서 보안은 어떻게 관리되나요?',
    a: 'AWS는 ISO 27001, HIPAA, PCI-DSS 등 다양한 글로벌 보안 인증을 획득하고 있으며, 네트워크 보안, 접근 제어, 암호화, 감사 로깅 등 다양한 보안 기능을 기본 제공합니다.',
  },
  {
    q: '기술 지원은 어떻게 받을 수 있나요?',
    a: '디엔에이클라우드 엔지니어들을 통해 24시간 기술지원을 받을 수 있으며, 컨설팅, 운영대행(MSP), 장애 대응 등 다양한 형태의 지원 서비스를 제공합니다.',
  },
];
function AWSCloudPage({ firstSectionRef }) {
  const [activeProductTab, setActiveProductTab] = useState(1);
  const productSwiper = useRef(null);
  const [productActiveIndex, setProductActiveIndex] = useState(0);
  const [progressPercent, setProgressPercent] = useState(0);
  const [perGroup, setPerGroup] = useState(3); // Swiper의 slidesPerGroup 값
  const [tooltipPercent, setTooltipPercent] = useState(0); // 툴팁 퍼센트
  const [tooltipVisible, setTooltipVisible] = useState(false); // 툴팁 보이기 여부
  const [activeFaqTab, setActiveFaqTab] = useState(0);
  const [portfolioActiveIndex, setPortfolioActiveIndex] = useState(1);
  const { setIsModalOpen, setModalContentKey, setModalSubContentKey } =
    useModal();

  const handleOpenModal = (key, index) => {
    setModalContentKey(key);
    setModalSubContentKey(index);
    setIsModalOpen(true);
  };
  useEffect(() => {
    if (productSwiper.current) {
      setPerGroup(productSwiper.current.params.slidesPerGroup || 1);
    }
  }, []);

  useEffect(() => {
    if (!productSwiper.current) return;

    const totalSlides = productSwiper.current.slides.length;
    const totalGroups = Math.ceil(totalSlides / perGroup);

    // 마지막 그룹이 아닌 경우에만 계산 (최종 슬라이드에서는 100%가 되어야 함)
    const currentProgress =
      productActiveIndex + perGroup < totalSlides
        ? ((productActiveIndex + perGroup) / totalSlides) * 100
        : 100; // 마지막 그룹에서는 100%

    setProgressPercent(currentProgress);
  }, [productActiveIndex, perGroup]);

  const handleMouseMove = (e) => {
    const rail = e.currentTarget;
    const railWidth = rail.offsetWidth;
    const mouseX = e.clientX - rail.getBoundingClientRect().left;
    const percent = (mouseX / railWidth) * 100;

    setTooltipPercent(Math.min(Math.max(percent, 0), 100)); // 0% ~ 100% 범위로 제한
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };
  const handleClick = (e) => {
    if (!productSwiper.current) return;

    const rail = e.currentTarget;
    const railWidth = rail.offsetWidth;
    const mouseX = e.clientX - rail.getBoundingClientRect().left;
    const percent = (mouseX / railWidth) * 100;

    // 전체 슬라이드 수와 perGroup을 고려하여 목표 슬라이드 인덱스를 계산
    const totalSlides = productSwiper.current.slides.length;
    const targetSlideIndex =
      Math.floor(((percent / 100) * totalSlides) / perGroup) * perGroup;

    // 목표 슬라이드 인덱스로 이동
    productSwiper.current.slideTo(targetSlideIndex);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // 애니메이션 지속 시간 (ms)
      easing: 'ease-out', // 애니메이션 이징 함수
      once: false, // 스크롤 후 한 번만 애니메이션 실행
    });
  }, []);
  const [solutionActiveIndex, setSolutionActiveIndex] = useState(0);
  const nhnSwiper = useRef(null);
  const [nhnSwiperActiveIndex, setNhnSwiperActiveIndex] = useState(0);
  return (
    <div className="awsCloudPageWrapper">
      <div
        data-aos="fade"
        data-aos-delay="0"
        data-aos-offset="0"
        ref={firstSectionRef}
        className="subHeroSection"
      >
        <div className="heroItem flex-col align-center justify-center">
          <div className="grid flex-col justify-center align-start">
            <div className="subHeroImage">
              <img src={heroImage} alt="" />
            </div>
            <div className="heroSliderItemText flex-col gap-48 justify-start">
              <div className="flex-col  gap-48">
                <div className="flex-col gap-32 ">
                  <div className="flex-col gap-20 ">
                    <div className="mainText">
                      <span>AWS 클라우드 서비스</span>
                    </div>
                  </div>
                  <div className="description">
                    <span>
                      <strong>
                        글로벌 인프라와 높은 확장성, 다양한 서비스 생태계를 갖춘
                      </strong>
                      AWS 클라우드를 경험해보세요.
                      <br />
                      디앤에이클라우드와 함께라면 복잡한 클라우드 여정도 쉽게
                      시작할 수 있습니다.
                      <br /> 비용 효율적인 설계부터 운영 최적화까지, AWS 전문
                      파트너가 도와드립니다.
                    </span>
                  </div>
                </div>
                <TransparentBtn to={'/contact'} text={'문의하기'} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="whyDnaCloudSection py-96 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <SectionTitle
            title={'디엔에이클라우드만의 장점'}
            titleCaption={'FEATURES & BENEFITS'}
          />
          <div className="cardWrap flex-row gap-16">
            <div className="card flex-full flex-col align-start gap-16 ">
              <div className="imgWrap">
                <img src={cloud1} alt="" />
              </div>
              <div className="textWrap pb-24  px-16 flex-col gap-40">
                <div className="flex-col gap-16">
                  <div className="divide"></div>
                  <div className="titleWrap">
                    <span>
                      AWS에 최적화된
                      <br />
                      전문 매니지드 서비스 제공
                    </span>
                  </div>
                  <div className="descriptionWrap">
                    <span>
                      다양한 산업군의 고객에게 맞춤형 아키텍처 설계, 구축, 운영
                      서비스를 제공합니다.
                    </span>
                  </div>
                </div>
                <div className="contactUsBtn flex-row gap-8 align-center">
                  <Link to={'/contact'}>
                    <div className="btnText">
                      <span>CONTACT US</span>
                    </div>
                  </Link>
                  <div className="btnIcon flex-row align-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M3 12.3359C3 13.5178 3.23279 14.6882 3.68508 15.7801C4.13738 16.872 4.80031 17.8642 5.63604 18.6999C6.47177 19.5356 7.46392 20.1986 8.55585 20.6509C9.64778 21.1031 10.8181 21.3359 12 21.3359C13.1819 21.3359 14.3522 21.1031 15.4442 20.6509C16.5361 20.1986 17.5282 19.5356 18.364 18.6999C19.1997 17.8642 19.8626 16.872 20.3149 15.7801C20.7672 14.6882 21 13.5178 21 12.3359C21 9.94899 20.0518 7.6598 18.364 5.97198C16.6761 4.28415 14.3869 3.33594 12 3.33594C9.61305 3.33594 7.32387 4.28415 5.63604 5.97198C3.94821 7.6598 3 9.94899 3 12.3359Z"
                        fill="#F7A436"
                        stroke="#F7A436"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 12.3359H15"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 9.33594L15.0581 12.3359L12 15.3359"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="card flex-full flex-col align-start gap-16 ">
              <div className="imgWrap">
                <img src={cloud2} alt="" />
              </div>
              <div className="textWrap pb-24 px-16 flex-col gap-40">
                <div className="flex-col gap-16">
                  <div className="divide"></div>
                  <div className="titleWrap">
                    <span>
                      비용 최적화 및
                      <br />
                      자원 효율성 극대화
                    </span>
                  </div>
                  <div className="descriptionWrap">
                    <span>
                      AWS 특성에 맞춘 리소스 분석과 비용 구조 진단을 통해
                      불필요한 지출은 줄이고, 성능은 유지하는 효율적인 운영
                      전략을 제시합니다.
                    </span>
                  </div>
                </div>
                <div className="contactUsBtn flex-row gap-8 align-center">
                  <Link to={'/contact'}>
                    <div className="btnText">
                      <span>CONTACT US</span>
                    </div>
                  </Link>
                  <div className="btnIcon flex-row align-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M3 12.3359C3 13.5178 3.23279 14.6882 3.68508 15.7801C4.13738 16.872 4.80031 17.8642 5.63604 18.6999C6.47177 19.5356 7.46392 20.1986 8.55585 20.6509C9.64778 21.1031 10.8181 21.3359 12 21.3359C13.1819 21.3359 14.3522 21.1031 15.4442 20.6509C16.5361 20.1986 17.5282 19.5356 18.364 18.6999C19.1997 17.8642 19.8626 16.872 20.3149 15.7801C20.7672 14.6882 21 13.5178 21 12.3359C21 9.94899 20.0518 7.6598 18.364 5.97198C16.6761 4.28415 14.3869 3.33594 12 3.33594C9.61305 3.33594 7.32387 4.28415 5.63604 5.97198C3.94821 7.6598 3 9.94899 3 12.3359Z"
                        fill="#F7A436"
                        stroke="#F7A436"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 12.3359H15"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 9.33594L15.0581 12.3359L12 15.3359"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="card flex-full flex-col align-start gap-16 ">
              <div className="imgWrap">
                <img src={cloud3} alt="" />
              </div>
              <div className="textWrap pb-24 px-16 flex-col gap-40">
                <div className="flex-col gap-16">
                  <div className="divide"></div>
                  <div className="titleWrap">
                    <span>
                      클라우드 보안 및
                      <br />
                      컴플라이언스 대응 지원
                    </span>
                  </div>
                  <div className="descriptionWrap">
                    <span>
                      AWS 보안 서비스와 연계한 실시간 모니터링, 접근 제어, 로그
                      관리 체계를 구축하여 기업의 내부 정책 및 외부 인증 기준에
                      맞춘 보안 환경을 제공합니다.
                    </span>
                  </div>
                </div>
                <div className="contactUsBtn flex-row gap-8 align-center">
                  <Link to={'/contact'}>
                    <div className="btnText">
                      <span>CONTACT US</span>
                    </div>
                  </Link>
                  <div className="btnIcon flex-row align-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M3 12.3359C3 13.5178 3.23279 14.6882 3.68508 15.7801C4.13738 16.872 4.80031 17.8642 5.63604 18.6999C6.47177 19.5356 7.46392 20.1986 8.55585 20.6509C9.64778 21.1031 10.8181 21.3359 12 21.3359C13.1819 21.3359 14.3522 21.1031 15.4442 20.6509C16.5361 20.1986 17.5282 19.5356 18.364 18.6999C19.1997 17.8642 19.8626 16.872 20.3149 15.7801C20.7672 14.6882 21 13.5178 21 12.3359C21 9.94899 20.0518 7.6598 18.364 5.97198C16.6761 4.28415 14.3869 3.33594 12 3.33594C9.61305 3.33594 7.32387 4.28415 5.63604 5.97198C3.94821 7.6598 3 9.94899 3 12.3359Z"
                        fill="#F7A436"
                        stroke="#F7A436"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 12.3359H15"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 9.33594L15.0581 12.3359L12 15.3359"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="card flex-full flex-col align-start gap-16 ">
              <div className="imgWrap">
                <img src={cloud4} alt="" />
              </div>
              <div className="textWrap pb-24 px-16 flex-col gap-40">
                <div className="flex-col gap-16">
                  <div className="divide"></div>
                  <div className="titleWrap">
                    <span>
                      24시간 기술지원 및
                      <br />
                      장애 대응 체계
                    </span>
                  </div>
                  <div className="descriptionWrap">
                    <span>
                      AWS 기반 시스템의 문제 발생 시, 전문 엔지니어가 신속하게
                      대응합니다. 실시간 모니터링과 티켓 기반 대응 시스템으로
                      중단 없는 서비스를 보장합니다.
                    </span>
                  </div>
                </div>
                <div className="contactUsBtn flex-row gap-8 align-center">
                  <Link to={'/contact'}>
                    <div className="btnText">
                      <span>CONTACT US</span>
                    </div>
                  </Link>
                  <div className="btnIcon flex-row align-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M3 12.3359C3 13.5178 3.23279 14.6882 3.68508 15.7801C4.13738 16.872 4.80031 17.8642 5.63604 18.6999C6.47177 19.5356 7.46392 20.1986 8.55585 20.6509C9.64778 21.1031 10.8181 21.3359 12 21.3359C13.1819 21.3359 14.3522 21.1031 15.4442 20.6509C16.5361 20.1986 17.5282 19.5356 18.364 18.6999C19.1997 17.8642 19.8626 16.872 20.3149 15.7801C20.7672 14.6882 21 13.5178 21 12.3359C21 9.94899 20.0518 7.6598 18.364 5.97198C16.6761 4.28415 14.3869 3.33594 12 3.33594C9.61305 3.33594 7.32387 4.28415 5.63604 5.97198C3.94821 7.6598 3 9.94899 3 12.3359Z"
                        fill="#F7A436"
                        stroke="#F7A436"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9 12.3359H15"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 9.33594L15.0581 12.3359L12 15.3359"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="serviceIntroSection pt-128 pb-160 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-56">
          <SectionTitle
            title={
              <>
                고객의 비즈니스 환경에 최적화된
                <br />
                Cloud 서비스
              </>
            }
            titleCaption={'SOLUTIONS'}
          />
          <div className="flex-col gap-32">
            <div className="categoryTabWrap flex-row gap-16">
              {solutionData.map((item, i) => {
                return (
                  <div
                    onClick={() => {
                      const isTabOrSmaller = window.innerWidth <= 960;
                      if (!isTabOrSmaller) {
                        setSolutionActiveIndex(i);
                      } else {
                        handleOpenModal('awsModal', i);
                      }
                    }}
                    className={`categoryTab flex-full align-center justify-center flex-col gap-8 ${i === solutionActiveIndex ? 'active' : ''}`}
                  >
                    <div className="iconWrap">
                      <img src={item.icon} alt="" />
                    </div>
                    <div
                      style={{
                        color:
                          i === solutionActiveIndex
                            ? item.titleColor
                            : '#484848',
                      }}
                      className={`text-center textWrap ${i === solutionActiveIndex ? 'active' : ''}`}
                    >
                      <span>{item.title}</span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="flex-row gap-16 serviceDescription">
              <div
                style={{
                  backgroundColor: solutionData[solutionActiveIndex].themeColor,
                }}
                className="colorBox flex-col  align-end justify-between"
              >
                <div className="titleWrap">
                  <span>{solutionData[solutionActiveIndex].enTitle}</span>
                </div>
                <div className="iconWrap">
                  <img
                    src={solutionData[solutionActiveIndex].lineIcon}
                    alt=""
                  />
                </div>
              </div>
              <div className="contentsBox px-24 flex-full gap-32 py-32 flex-col">
                <div className="contentTitle">
                  <span> {solutionData[solutionActiveIndex].contentTitle}</span>
                </div>
                <div className="divide "></div>
                <div className="contentsList flex-col gap-32">
                  {solutionData[solutionActiveIndex].contentData.map(
                    (item, i) => {
                      return (
                        <div className={'flex-row align-center gap-24'}>
                          <div className={`contentNum`}>
                            <span>0{i + 1}</span>
                          </div>
                          <div className="content">
                            <span>{item}</span>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
          </div>
          {/*<div className="content flex-row gap-80 align-end">*/}
          {/*  <div className="imgWrap tab:display-none">*/}
          {/*    <img src={icon3d1} alt="" />*/}
          {/*  </div>*/}
          {/*  <div className="textWrap flex-col gap-24">*/}
          {/*    <div className="numWrap">*/}
          {/*      <span>01</span>*/}
          {/*    </div>*/}
          {/*    <div*/}
          {/*      className="titleWrap flex-col gap-20 pb-24*/}
          {/*    "*/}
          {/*    >*/}
          {/*      <div className="main">*/}
          {/*        <span>금융 특화 클라우드 솔루션</span>*/}
          {/*      </div>*/}
          {/*      <div className="sub">*/}
          {/*        <span>*/}
          {/*          금융 산업에 최적화된 클라우드 환경과*/}
          {/*          <br />*/}
          {/*          강력한 보안 체계를 제공합니다*/}
          {/*        </span>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div className="descriptionList flex-col gap-32">*/}
          {/*      <div className="desItem flex-row gap-12 align-start">*/}
          {/*        <div className="desNum flex-row align-center justify-center">*/}
          {/*          <span>01</span>*/}
          {/*        </div>*/}
          {/*        <div className="desText">*/}
          {/*          <span>*/}
          {/*            금융 서비스 운영에 최적화된 논리적 환경을 구축하여*/}
          {/*            <br />*/}
          {/*            안전하고 효율적인 클라우드 인프라를 제공*/}
          {/*          </span>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*      <div className="desItem flex-row gap-12 align-start">*/}
          {/*        <div className="desNum flex-row align-center justify-center">*/}
          {/*          <span>02</span>*/}
          {/*        </div>*/}
          {/*        <div className="desText">*/}
          {/*          <span>*/}
          {/*            금융보안원의 클라우드 이용 가이드라인을 철저히 준수하며*/}
          {/*            <br />*/}
          {/*            기본 및 추가 보호 조치까지 완벽하게 충족*/}
          {/*          </span>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="content flex-row gap-80 align-end">*/}
          {/*  <div className="imgWrap tab:display-none">*/}
          {/*    <img src={icon3d2} alt="" />*/}
          {/*  </div>*/}
          {/*  <div className="textWrap flex-col gap-24">*/}
          {/*    <div className="numWrap">*/}
          {/*      <span>02</span>*/}
          {/*    </div>*/}
          {/*    <div*/}
          {/*      className="titleWrap flex-col gap-20 pb-24*/}
          {/*    "*/}
          {/*    >*/}
          {/*      <div className="main">*/}
          {/*        <span>커머스 특화 클라우드 솔루션</span>*/}
          {/*      </div>*/}
          {/*      <div className="sub">*/}
          {/*        <span>*/}
          {/*          성장하는 비즈니스를 위한*/}
          {/*          <br />*/}
          {/*          맞춤형 커머스 클라우드 서비스를 제공합니다.*/}
          {/*        </span>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div className="descriptionList flex-col gap-32">*/}
          {/*      <div className="desItem flex-row gap-12 align-start">*/}
          {/*        <div className="desNum flex-row align-center justify-center">*/}
          {/*          <span>01</span>*/}
          {/*        </div>*/}
          {/*        <div className="desText">*/}
          {/*          <span>*/}
          {/*            비즈니스 규모에 맞춰 확장성과 안정성을 갖춘 최적의*/}
          {/*            인프라를 구축할 수 있도록 지원합니다.*/}
          {/*          </span>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*      <div className="desItem flex-row gap-12 align-start">*/}
          {/*        <div className="desNum flex-row align-center justify-center">*/}
          {/*          <span>02</span>*/}
          {/*        </div>*/}
          {/*        <div className="desText">*/}
          {/*          <span>*/}
          {/*            사업 규모와 운영 범위에 따라 최적화된 이커머스 솔루션을*/}
          {/*            제공하여 경쟁력을 강화합니다.*/}
          {/*          </span>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*      <div className="desItem flex-row gap-12 align-start">*/}
          {/*        <div className="desNum flex-row align-center justify-center">*/}
          {/*          <span>03</span>*/}
          {/*        </div>*/}
          {/*        <div className="desText">*/}
          {/*          <span>*/}
          {/*            커머스에 필요한 핵심 서비스를 올인원으로 제공하여*/}
          {/*            <br />*/}
          {/*            빠른 시장 진입과 글로벌 확장을 돕습니다.*/}
          {/*          </span>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
      <div className="cloudBannerSection nhn pb-128">
        <Swiper
          onSwiper={(swiper) => (nhnSwiper.current = swiper)}
          className={'nhnBannerSwiper'}
          onSlideChange={(swiper) => setNhnSwiperActiveIndex(swiper.realIndex)}
          modules={[EffectCreative, Autoplay]}
          effect="creative"
          creativeEffect={{
            prev: {
              shadow: true,
              translate: ['-80%', 0, 0],
            },
            next: {
              translate: ['100%', 0, 0],
            },
          }}
          slidesPerView={1}
          autoplay={true}
          autoplaySpeed={800}
          centeredSlides={true}
          loopAdditionalSlides={1}
          touchReleaseOnEdges={false}
          speed={800}
          spaceBetween={0}
          loop={true}
        >
          <SwiperSlide
            className={' nhnSliderCustomItem flex-row justify-center'}
          >
            <div className="imgWrap">
              <img src={naverSlider1} alt="" />
            </div>
            <div className="grid flex-col gap-96">
              <div className="textWrap py-96 flex-col gap-40">
                <div className="main">
                  <span>
                    가장 광범위한
                    <br />
                    글로벌 인프라
                  </span>
                </div>
                <div className="sub">
                  <span>
                    AWS는 가장 광범위한 글로벌 클라우드 인프라를 갖추고
                    있습니다.
                    <br />전 세계 25개의 지리적 리전 내에 81개의 가용 영역을
                    운영하고 있으며,
                    <br />
                    앞으로 호주, 인도, 인도네시아, 스페인, 스위스 및
                    아랍에미리트(UAE)에 6개의 AWS리전과 18개의 가용 영역을
                    추가할 계획입니다.
                  </span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="certSection pb-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-32 ">
          <div className="flex-row tab:flex-col  gap-16 justify-between">
            <SectionTitle
              title={
                <>
                  글로벌 클라우드,
                  <br />
                  AWS의 안정성과 신뢰를 경험하세요
                </>
              }
              titleCaption={'GLOBAL'}
              // background={hostingIntroBackground}
              description={
                <>
                  AWS는 세계 각지에 분산된 인프라와 글로벌 보안 표준에 기반하여
                  기업이 안전하고 확장 가능한 환경에서 클라우드를 운영할 수
                  있도록 지원합니다.
                  <br />
                  최고 수준의 보안, 컴플라이언스, 가용성을 갖춘 AWS와 함께
                  글로벌 비즈니스의 시작과 확장을 동시에 실현해보세요.
                </>
              }
            />

            <div className="imgWrap ">
              <div className="layerOne">
                <img src={awsMapImg} alt="" />
              </div>
            </div>
          </div>
          <div className="moreProductBannerWrap obj py-40 flex-row gap-24 align-start px-40 justify-between">
            <div className="textWrap flex-col gap-16 align-start">
              <div className="title">
                <span>
                  전문가의 무료 컨설팅으로
                  <br />
                  최적의 인프라 구성안을 제안 드립니다.
                </span>
              </div>
              <BlackArrowBtn to={'/contact'} text={'컨설팅 신청'} />
            </div>
            <div className="imgWrap flex-row align-center justify-center">
              <img src={productBannerForCorocation} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="faqSection pb-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <SectionTitle
            title={'자주 묻는 질문'}
            titleCaption={'FAQ'}
            description={<>AWS 클라우드에 대해 좀 더 궁금하신가요?</>}
          />
          <div className="faqListWrap">
            {qnaData?.map((item, i) => {
              return (
                <div
                  onClick={() =>
                    setActiveFaqTab(activeFaqTab === i + 1 ? 0 : i + 1)
                  }
                  className="faqItem flex-col gap-8 py-24"
                >
                  <div className="faqQ px-16  flex-row gap-16 justify-between">
                    <div className="flex-col gap-16">
                      <div className="label">
                        <span>Q</span>
                      </div>
                      <div className="title">
                        <span>{item?.q}</span>
                      </div>
                    </div>
                    <div
                      className={`iconWrap flex-col justify-center align-center icon-24 ${activeFaqTab === i + 1 ? 'active' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="9"
                        viewBox="0 0 14 9"
                        fill="none"
                      >
                        <path
                          d="M1.08008 7.68677L7.01758 1.83495L12.9551 7.68677"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    className={`faqA flex-col px-16 ${activeFaqTab === i + 1 ? 'active py-16' : ''}`}
                  >
                    <div className="content">
                      <span>{item?.a}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ctaBanner pb-128 flex-col justify-center align-center"
      >
        <div className="grid py-40">
          <div className="bannerImage">
            <img src={bannerImg} alt="" />
          </div>
          <div className="titleWrap px-40 flex-col gap-48">
            <div className="flex-col gap-16">
              <div className="main">
                <span>최고의 파트너를 찾으시나요?</span>
              </div>
              <div className="description">
                <span>
                  디앤에이클라우드의 전문가들과 함께
                  <br />
                  최적의 인프라를 통해 비즈니스를 확장하세요
                </span>
              </div>
            </div>
            <Link to={'/contact'}>
              <div className="primaryBtn44">
                <span>문의하기</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AWSCloudPage;
